// ABOUTME: The one trash icon of the app — outline, currentColor, from the mocks
// ABOUTME: There used to be four (filled, white, 14px, lucide's); this is all of them

interface Trash2IconProps {
  className?: string
  /** Pixel size; a `w-*`/`h-*` class in className wins over it. */
  size?: number
}

export const Trash2Icon = ({ className = "", size = 16 }: Trash2IconProps) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4 7h16M9 7V5h6v2M6 7l1 13h10l1-13" />
  </svg>
)
